<script setup lang="ts">
import { getSiteMapRacks } from '@/services/eos/site-map'
import type { ISiteMapRack } from '@/types/eos/SiteMap'
import type { ISiteMapRackFilters } from '@/types/eos/filters'
import { ElMessage } from 'element-plus'
import type { OptionType } from 'element-plus/es/components/select-v2/src/select.types.mjs'
import { ref, watch } from 'vue'

const props = withDefaults(defineProps<{ placeholder?: string; siteId?: string; structureId?: string }>(), {
  placeholder: 'Select Rack',
})

const selectedValue = defineModel<ISiteMapRack>()

const filterLoading = ref(false)
const filterOptions = ref<OptionType[]>([])

const filterValues = async (query: string) => {
  try {
    filterLoading.value = true

    const filters: ISiteMapRackFilters = {
      page: 1,
      per_page: 1000,
      order_by: 'name',
      site_id: props.siteId,
      structure_id: props.structureId,
    }

    if (query) {
      filters.name = query
    }

    const filteredResources = await getSiteMapRacks(filters)
    filterOptions.value = filteredResources.data.map((res: ISiteMapRack) => {
      return {
        label: res.name,
        value: res,
      }
    })
  } catch {
    ElMessage.error('Failed to filter racks')
    filterOptions.value = []
  } finally {
    filterLoading.value = false
  }
}

// Add a watch to check selectedEquipmentType changes
watch(selectedValue, () => {
  if (selectedValue.value) {
    filterOptions.value.push({
      label: selectedValue.value.name,
      value: selectedValue.value,
    })
  }
})
</script>

<template>
  <el-select-v2
    v-model="selectedValue"
    :options="filterOptions"
    :loading="filterLoading"
    remote
    :remote-method="filterValues"
    filterable
    clearable
    value-key="id"
    :placeholder="props.placeholder"
    loading-text="Loading..."
  />
</template>
